// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const BACKGROUND_DESCRIPTOR = msg({
	message: 'Background',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const PLUTONIUM_DESCRIPTOR = msg({
	message: 'Plutonium',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const LOGIN_DESCRIPTOR = msg({
	message: 'Login',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const CODES_DESCRIPTOR = msg({
	message: 'Codes',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const INBOX_DESCRIPTOR = msg({
	message: 'Inbox',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const DEVELOPER_DESCRIPTOR = msg({
	message: 'Developer',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const APPLICATIONS_DESCRIPTOR = msg({
	message: 'Applications',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const AUTHORIZATION_DESCRIPTOR = msg({
	message: 'Authorization',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
export const GIFTS_DESCRIPTOR = msg({
	message: 'Gifts',
	comment: 'Settings search entry label. Also used as a search synonym in the settings search bar.',
});
